import { render, staticRenderFns } from "./PaySuccessModel.vue?vue&type=template&id=6d0c4131&scoped=true&"
import script from "./PaySuccessModel.vue?vue&type=script&lang=js&"
export * from "./PaySuccessModel.vue?vue&type=script&lang=js&"
import style0 from "./PaySuccessModel.vue?vue&type=style&index=0&id=6d0c4131&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0c4131",
  null
  
)

export default component.exports